module.exports = __webpack_public_path__ + "static/media/dog-final.76e79b10.svg";